import React from 'react';
import { useTranslation } from 'react-i18next';
import { AgentState } from '../../types';
import { ManualDialPanel } from './ManualDialPanel';
import idleStyles from './AgentWidgetIdle.module.css';

interface AgentWidgetIdleStateProps {
  agentState: AgentState;
  onManualDial?: (phoneNumber: string) => Promise<void>;
}

export function AgentWidgetIdleState({ agentState, onManualDial }: AgentWidgetIdleStateProps) {
  const { t } = useTranslation();
  const isAvailable = agentState.state?.toLowerCase() === 'available';

  return (
    <div className={idleStyles.idleState}>
      <div className={idleStyles.idleHero}>
        <div className={isAvailable ? idleStyles.idleIcon : idleStyles.idleIconUnavailable}>
          <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
            <path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z" />
          </svg>
        </div>
        <h2 className={idleStyles.idleTitle}>
          {isAvailable ? t('agent:idle.readyForCalls') : t('agent:idle.notReceivingCalls')}
        </h2>
        <p className={idleStyles.idleText}>
          {isAvailable
            ? t('agent:idle.availableDescription')
            : t('agent:idle.unavailableDescription')}
        </p>
        {!isAvailable && agentState.reason && (
          <p className={idleStyles.reasonText}>{agentState.reason}</p>
        )}
      </div>
      {isAvailable && onManualDial && <ManualDialPanel onDial={onManualDial} />}
    </div>
  );
}

export default AgentWidgetIdleState;
